import {
  AspectRatio,
  Resolution,
} from 'src/domains/calculators/utilities/types';
import { roundToNearestEven } from 'src/domains/calculators/utilities/round';

/*
 * Get protection resolution based on various parameters
 * This resolution represents the largest area within the effective canvas representing the aspect ratio
 * It is not affected by protection, rather it represents the 'edge' of the framing decision at 0% protection
 */
export function getProtectionResolution({
  aspectRatio,
  containerResolution,
  squeeze = 1,
  desqueezed = false,
}: {
  aspectRatio: AspectRatio;
  containerResolution: Resolution;
  squeeze: number;
  desqueezed?: boolean;
}): Resolution {
  const { width: containerWidth, height: containerHeight } =
    containerResolution;

  const maxAspectRatioResolution = {
    width: containerWidth,
    height: containerHeight,
  };

  let aspectResolution = { ...maxAspectRatioResolution };
  const effectiveSqueeze = desqueezed ? 1 : squeeze;

  // Set the aspect resolution width
  aspectResolution.width =
    (containerHeight * aspectRatio[0]) / aspectRatio[1] / effectiveSqueeze;

  if (aspectResolution.width > containerWidth) {
    // If the calculated width exceeds the sensor width, adjust the height
    aspectResolution = { ...maxAspectRatioResolution };
    aspectResolution.height =
      ((containerWidth * effectiveSqueeze) / aspectRatio[0]) * aspectRatio[1];
  }

  // Round resolution values
  aspectResolution = {
    width: roundToNearestEven(aspectResolution.width),
    height: roundToNearestEven(aspectResolution.height),
  };

  return aspectResolution;
}
